/* tslint:disable */
/* eslint-disable */
/* @relayHash 0446928955970b59719768048eafdff2 */

import { ConcreteRequest } from "relay-runtime";
export type SourceAttributionInput = {
    guestUserId?: string | null;
    landingPage?: string | null;
    type: string;
    userId: string;
    userToken?: string | null;
    emailToken?: string | null;
    visitCount?: number | null;
    pageVisits?: Array<pageVisits | null> | null;
    clientMutationId?: string | null;
};
export type pageVisits = {
    date?: string | null;
    type?: string | null;
    utmParams?: utmParams | null;
};
export type utmParams = {
    landingPage?: string | null;
    visitCount?: number | null;
};
export type sourceAttributionMutationVariables = {
    input: SourceAttributionInput;
};
export type sourceAttributionMutationResponse = {
    readonly sourceAttribution: {
        readonly message: string | null;
    } | null;
};
export type sourceAttributionMutation = {
    readonly response: sourceAttributionMutationResponse;
    readonly variables: sourceAttributionMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SourceAttributionPayload",
    "kind": "LinkedField",
    "name": "sourceAttribution",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sourceAttributionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sourceAttributionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/311.0.0-2021-04-21T17:34:53.450Z/sourceAttributionMutation",
    "metadata": {},
    "name": "sourceAttributionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '0776fc099f129d46b7995c62aa8613ee';
export default node;
